import { Portal } from '@chakra-ui/react'
import { useEffect } from 'react'

import Text from 'components/common/Text/Text'
import { old_COLOR } from 'styles/constants/old_color'
import { old_FONT_SIZE } from 'styles/constants/old_fontSize'
import { old_SPACE } from 'styles/constants/old_space'

import Box from '../Box/Box'
import FlexBox from '../FlexBox/FlexBox'
import Spinner from './Spinner'

type Props = {
  subText?: string
  text?: string
}
/**
 * Application level modal loader that can overlay the whole page
 */
function ModalLoader({ subText, text }: Props) {
  useEffect(() => {
    document.body.classList.add('no-scroll')

    return () => {
      document.body.classList.remove('no-scroll')
    }
  }, [])

  return (
    <Portal>
      <FlexBox
        flexDirection="column"
        opacity={0.9}
        style={{ position: 'fixed', ...styles.modal }}
      >
        <Box>
          <Spinner size="large" />
        </Box>
        {text && (
          <Box marginTop={old_SPACE.sp16}>
            <Text color={old_COLOR.white} fontSize={old_FONT_SIZE.fs32}>
              {text}
            </Text>
          </Box>
        )}
        {subText && (
          <Box>
            <Text color={old_COLOR.white} fontSize={old_FONT_SIZE.fs20}>
              {subText}
            </Text>
          </Box>
        )}
      </FlexBox>
    </Portal>
  )
}

const styles = {
  modal: {
    alignItems: 'center',
    background: 'rgba(0,0,0,0.4)',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
    zIndex: '1400',
    // positions
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  spinnerContainer: {
    opacity: 0.8,
  },
}

export default ModalLoader
